import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';

const IntegerField = ({
  field,
  useFormRef,
  schema,
  disabled,
  allowNegative = false,
  ...props
}) => {
  const { control } = useFormRef;
  return (
    <Controller
      name={field}
      control={control}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error }
      }) => (
        <NumberFormat
          thousandSeparator="."
          decimalSeparator={false}
          customInput={TextField}
          onValueChange={values => {
            onChange(values.value);
          }}
          value={value || ''}
          label={schema?.fields[field]?.spec?.label}
          required={schema?.fields[field]?.exclusiveTests['required']}
          error={!!error}
          helperText={error?.message}
          onBlur={onBlur}
          name={name}
          inputRef={ref}
          disabled={disabled}
          {...props}
        />
      )}
    />
  );
};

export default IntegerField;
